import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import LoansTable from '../components/LoansTable';

const LoansPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <LoansTable></LoansTable>
    </Container>
  )
}
export default withAuth (LoansPage, ['admin', 'agent'])